import LinkButton from "flarum/common/components/LinkButton";

export default class RajceLinkButton extends LinkButton {
  view(vnode) {
    const vdom = super.view(vnode);

    vdom.tag = 'a';
    vdom.attrs.target = '_blank';

    delete vdom.attrs.type;

    return vdom;
  }

  static isActive(props) {
    return typeof props.active !== 'undefined' ? props.active : false;
  }
}
